import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/services";

const LAYOUT = {
  "gros-travaux": { span: "lg:col-span-2 lg:row-span-2", bg: "bg-[#003366] text-white", accent: true },
  "recherche-fuites": { span: "lg:col-span-1", bg: "bg-white" },
  "intervention-ponctuelle": { span: "lg:col-span-1", bg: "bg-white" },
  "entretien-toitures": { span: "lg:col-span-2", bg: "bg-[#F2F4F7]" },
  "resines-revetements": { span: "lg:col-span-1", bg: "bg-[#F2F4F7]" },
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-block w-10 h-px bg-[#FF5A1F]" />
              <span className="label-kicker text-[#FF5A1F]">Nos prestations</span>
            </div>
            <h2
              data-testid="services-title"
              className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#0F172A] leading-[1]"
            >
              Un métier,
              <br /> cinq expertises.
            </h2>
          </div>
          <p className="lg:col-span-6 lg:col-start-7 text-base md:text-lg text-slate-600 leading-relaxed self-end">
            De la réfection complète aux réparations d'urgence, ETANCIA prend en
            charge chaque mètre carré de votre toiture-terrasse avec la
            rigueur d'un étancheur de métier et la réactivité d'une équipe de
            proximité.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border-l border-t border-slate-200">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const layout = LAYOUT[s.slug];
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`service-card-${i}`}
                className={`group relative ${layout.span} ${layout.bg} border-r border-b border-slate-200 p-7 lg:p-10 flex flex-col justify-between min-h-[260px] transition-colors hover:brightness-105`}
              >
                <div className="flex items-start justify-between">
                  <div
                    className={`w-12 h-12 flex items-center justify-center ${
                      layout.accent ? "bg-[#FF5A1F]" : "bg-[#003366]"
                    } text-white`}
                  >
                    <Icon className="w-5 h-5" />
                  </div>
                  <ArrowUpRight
                    className={`w-5 h-5 opacity-40 group-hover:opacity-100 group-hover:text-[#FF5A1F] transition ${
                      layout.accent ? "text-white" : "text-slate-500"
                    }`}
                  />
                </div>
                <div className="mt-8">
                  <h3
                    className={`font-display font-bold text-xl md:text-2xl leading-tight ${
                      layout.accent ? "text-white" : "text-[#0F172A]"
                    }`}
                  >
                    {s.title}
                  </h3>
                  <p
                    className={`mt-3 text-sm md:text-[15px] leading-relaxed ${
                      layout.accent ? "text-slate-200" : "text-slate-600"
                    }`}
                  >
                    {s.shortDesc}
                  </p>
                  {s.references && s.references.length > 0 && (
                    <span
                      className={`mt-5 inline-flex items-center gap-1 text-xs font-semibold uppercase tracking-[0.18em] ${
                        layout.accent ? "text-[#FF9A6F]" : "text-[#FF5A1F]"
                      }`}
                    >
                      Voir les chantiers <ArrowUpRight className="w-3.5 h-3.5" />
                    </span>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
